export default __webpack_public_path__ + "static/media/serenityyetmis3.e18284eb.jpg";